import { render, staticRenderFns } from "./HighlightedProducts.vue?vue&type=template&id=11587139&scoped=true&"
import script from "./HighlightedProducts.vue?vue&type=script&lang=js&"
export * from "./HighlightedProducts.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedProducts.vue?vue&type=style&index=0&id=11587139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11587139",
  null
  
)

export default component.exports